module.exports = __webpack_public_path__ + "img/73200.b4c95d2f.jpg";